import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

import { Card, Typography } from '@mui/material';

const PREFIX = 'ProfileUserView';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {},
}));

const ProfileUserView = props => {
  const { className, data, ...rest } = props;

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <br />
      <Typography variant='caption'>Имя пользователя</Typography>
      <Typography variant='h3'>{data.user.displayName}</Typography>
      <br />
      <Typography variant='caption'>email</Typography>
      <Typography variant='h3'>{data.user.email}</Typography>
    </StyledCard>
  );
};

export default ProfileUserView;
